<template>
    <rkm-overlay>
        <rkm-layout-body title="Monitoramento de protocolos">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/regulacao/monitoramento-protocolo/List'

export default {
    components: { List },
}
</script>